export enum MasterDataType {
  Address = 'ADDRESS',
  Carrier = 'CARRIER',
  GateAddress = 'GATE_ADDRESS',
  User = 'USER',
  ShipsGoManualUpload = 'SHIPSGO_MANUAL_UPLOAD',
}
